<h3>{{ 'admin.aff.titre' | traduire }}</h3>

<div class="form-choix">
  <label>{{ 'admin.aff.choisirEvenement' | traduire }}</label>
  <select [(ngModel)]="evenementChoisiId" (ngModelChange)="onChoixEvenement()">
    <option [ngValue]="null">{{ 'admin.aff.selectionner' | traduire }}</option>
    <option *ngFor="let ev of evenements" [ngValue]="ev.id">{{ ev.titre }}</option>
  </select>
</div>

<div class="form-ia" *ngIf="evenementChoisiId !== null">
  <label class="titre-section">🤖 {{ 'admin.aff.iaTitre' | traduire }} <span class="tag-gratuit">{{ 'admin.aff.iaGratuit' | traduire }}</span></label>
  <p class="astuce-ia">{{ 'admin.aff.iaExplication' | traduire }}</p>

  <div class="ligne-ia">
    <input type="text" [(ngModel)]="promptIA" [placeholder]="'admin.aff.iaPlaceholder' | traduire" [disabled]="chargementImageIA">
    <button type="button" (click)="genererImageIA()" [disabled]="chargementImageIA || !promptIA.trim()">
      {{ chargementImageIA ? ('admin.aff.iaGeneration' | traduire) : (imageIA ? ('admin.aff.iaRegenerer' | traduire) : ('admin.aff.iaGenererBtn' | traduire)) }}
    </button>
  </div>

  <p class="erreur-ia" *ngIf="erreurImageIA">{{ erreurImageIA }}</p>

  <label class="case" *ngIf="imageIA">
    <input type="checkbox" [(ngModel)]="utiliserImageIA" (ngModelChange)="genererAffiche()">
    {{ 'admin.aff.iaUtiliser' | traduire }}
  </label>
</div>

<div class="form-personnalisation" *ngIf="evenementChoisiId !== null">
  <label class="titre-section">{{ 'admin.aff.personnaliser' | traduire }}</label>

  <div class="options-cases">
    <label class="case"><input type="checkbox" [(ngModel)]="afficherPrix" (ngModelChange)="genererAffiche()"> {{ 'admin.aff.afficherPrix' | traduire }}</label>
    <label class="case"><input type="checkbox" [(ngModel)]="afficherDate" (ngModelChange)="genererAffiche()"> {{ 'admin.aff.afficherDate' | traduire }}</label>
    <label class="case"><input type="checkbox" [(ngModel)]="afficherLieu" (ngModelChange)="genererAffiche()"> {{ 'admin.aff.afficherLieu' | traduire }}</label>
  </div>

  <div class="ligne-options">
    <div>
      <label>{{ 'admin.aff.mention' | traduire }}</label>
      <input type="text" [(ngModel)]="mention" (ngModelChange)="genererAffiche()"
             placeholder="ex. NOUVEAU, COMPLET, -20%" maxlength="20">
    </div>
    <div>
      <label>{{ 'admin.aff.theme' | traduire }}</label>
      <select [(ngModel)]="theme" (ngModelChange)="genererAffiche()">
        <option value="dore">{{ 'admin.aff.themeDore' | traduire }}</option>
        <option value="corail">{{ 'admin.aff.themeCorail' | traduire }}</option>
        <option value="sombre">{{ 'admin.aff.themeSombre' | traduire }}</option>
      </select>
    </div>
  </div>
</div>

<div class="affiche-zone">
  <canvas #canvasAffiche width="500" height="625"></canvas>
  <div class="affiche-actions">
    <button (click)="telechargerAffiche()">⬇ {{ 'admin.aff.telecharger' | traduire }}</button>
    <p class="astuce">{{ 'admin.aff.explication' | traduire }}</p>
  </div>
</div>
